export default function Divider() {
  return <span className="typo__bordeaux-color--50">&#8213;</span>
}
